import React from 'react';

const Filters = () => {
  return (
    <div className="bg-secondary py-3">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <div className="flex space-x-4">
          <button className=" px-4 py-2 rounded px-4 py-2 rounded hover:bg-primary">Régions</button>
          <button className="px-4 py-2 rounded text-white px-4 py-2 rounded hover:bg-primary">Salles</button>
          <button className="px-4 py-2 rounded text-white px-4 py-2 rounded hover:bg-primary">Catégories</button>
        </div>
        <div>
          <input
            type="text"
            placeholder="Rechercher"
            className="px-4 py-2 rounded-full w-60"
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
